module.exports = __webpack_public_path__ + "img/support_blue.5c585b57.png";